<template>
	<div class="m-l-50 m-t-0 w-1200">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="权限组名称" prop="power_name">
        <el-input v-model.trim="form.power_name" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="权限分配" prop="reason">
        <div class="bor-gray h-600 ovf-y-auto bor-ra-5 bg-wh">
          <div v-for="(item,index) in form.menu_list">
            <div class="p-l-20 bor-b-ccc">
              <el-checkbox v-model="item.check" v-on:change="selectModuleRule(index)">{{item.menu_name}}</el-checkbox>
            </div>
            <div class="p-l-40 bor-b-ccc bg-gra">
              <el-checkbox v-for="son_item in item.child" v-model="son_item.check" v-on:change="selectActionRule(son_item.check,index)">{{son_item.name}}</el-checkbox>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading" size="small">保 存</el-button>
        <el-button @click="goback()" size="small">返 回</el-button>
      </el-form-item>
		</el-form>
	</div>
</template>
<style>
	.form-checkbox:first-child{
		margin-left: 15px;
	}
  .item {
    margin: 4px;
  }
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  export default {
    data() {
      return {
        isLoading: false,
        id: null,
        form: {
          id: '',
          power_name: '',
          menu_list: ''
        },
        rules: {
          power_name: [
            { required: true, message: '请输入权限组名称' }
          ]
        }
      }
    },
    methods: {
      selectModuleRule(index) {
        if (this.form.menu_list[index].check){
          _(this.form.menu_list[index].child).forEach((res, i) => {
            this.form.menu_list[index].child[i].check = true
          })
        } else {
          _(this.form.menu_list[index].child).forEach((res, i) => {
            this.form.menu_list[index].child[i].check = false
          })
        }
      },
      selectActionRule(check, index) {
        if (check) {
          this.form.menu_list[index].check = true
        } else {
          let num = 0
          _(this.form.menu_list[index].child).forEach((res, i) => {
            if (this.form.menu_list[index].child[i].check == false) {
              num++
            }
          })
          if (num >= this.form.menu_list[index].child.length) {
            this.form.menu_list[index].check = false
          }
        }
      },
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPut('admin/power/', this.id, this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      async getCompleteData() {
        this.apiGet('admin/power/' + this.id).then((res) => {
          this.handelResponse(res, (data) => {
            this.form.power_name = data.power_name
            this.form.menu_list = data.menu_list
            this.form.id = data.id
          })
        })
      }
    },
    created() {
      this.id = this.$route.params.id
      this.getCompleteData()
    },
    components: {
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?bc7a3cac